module.exports = __webpack_public_path__ + "static/img/1_hello.a325d697.jpg";